import React from 'react';

export const LiveGoodsMessaging = () => {
  return (
    <div className="store__message">
      <span className="store__dark">
        Is this in season? Check this plant&apos;s in-store availability and other details.
      </span>
    </div>
  );
};
